import { render, staticRenderFns } from "./TravelOrders.vue?vue&type=template&id=71d5a87c"
import script from "./TravelOrders.vue?vue&type=script&lang=js"
export * from "./TravelOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports